module.exports = "<div class=\"inspirationDetail\" ng-class=\"{'has-smallFormatCards': forceSmallFormatView}\">\r\n    <oly-dynamic-content schedule-key=\"scheduleKey()\"\r\n                         onload=\"checkMediumFormat()\"\r\n                         force-small-format-view=\"forceSmallFormatView\"\r\n                         small-format-stamp-size=\"responsiveSize\">\r\n    </oly-dynamic-content>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/inspiration/inspiration-detail-template.html
 ** module id = 956
 ** module chunks = 1
 **/